const parsePhoneNumber = (number) => {
  if (!number) return ''

  const digitsOnly = number.replace(/[^\d]/g, '')

  // Drop any country-code prefix (+1, +52, +521, etc.) by keeping the last
  // 10 digits — every supported region uses 10-digit national numbers.
  return digitsOnly.length > 10 ? digitsOnly.slice(-10) : digitsOnly
}

export default parsePhoneNumber
